import { GatsbySSR } from 'gatsby';
import React from 'react';
import { ClaimProvider } from './src/context/ClaimContext';

export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({ element }) => (
  <ClaimProvider>{element}</ClaimProvider>
);
